import { isInPortal } from "utilities/portal/portal";

export function useIsDraftBillsEffective(): boolean {
    return isInPortal({ builder: true });
}
